import Lockr from 'lockr'
import * as keys from './store-keys'

export const token = Lockr.get(keys.TOKEN, {})

export const currentUser = Lockr.get(keys.CURRENT_USER, {})

export const loading = {show: false}



// WEBPACK FOOTER //
// ./src/store/state.js